import { useIntl } from '@zenbusiness/application-commons-intl';
import Avatar from '@zenbusiness/zui/Avatar';
import Text from '@zenbusiness/zui/Text';

import { VELO_AVATAR_SRC } from '../constants';
import { StyledHelpRow } from '../SubscriptionCancelPage.styles';

export function SubscriptionCancelHelp() {
  const { formatMessage } = useIntl();

  return (
    <StyledHelpRow>
      <Avatar
        src={VELO_AVATAR_SRC}
        alt={formatMessage({ id: 'dashboard.subscriptionCancel.help.avatarAlt' })}
        sx={{ width: 40, height: 40 }}
      />
      <Text size="md" color="secondary">
        {formatMessage({ id: 'dashboard.subscriptionCancel.help.message' })}
      </Text>
    </StyledHelpRow>
  );
}
